import Iconify from "@/components/ui/Iconify";
import { useRef } from "react";

const distanceTabs = [
  { label: "100m", value: 100 },
  { label: "300m", value: 300 },
  { label: "500m", value: 500 },
  { label: "1km", value: 1000 },
  { label: "2km", value: 2000 },
  { label: "3km", value: 3000 },
  { label: "5km", value: 5000 },
  { label: "10km", value: 10000 },
  { label: "15km", value: 15000 },
  { label: "20km", value: 20000 },
];

const PlacesMapsDistanceFilterTabs = ({ handleRadiusChange, mapRadius }) => {
  const tabsContainerRef = useRef(null);

  const handleRightScrollClick = () => {
    if (tabsContainerRef.current) {
      tabsContainerRef.current.scrollBy({
        left: 200,
        behavior: "smooth",
      });
    }
  };

  const handleLeftScrollClick = () => {
    if (tabsContainerRef.current) {
      tabsContainerRef.current.scrollBy({
        left: -200,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="w-full bg-black/60 flex pl-2 relative h-[40px] z-20">
      <button
        type="button"
        onClick={handleLeftScrollClick}
        className="absolute bg-black/30 left-0 top-0 bottom-0 w-fit flex items-center justify-center px-2 z-20"
      >
        <Iconify icon={"formkit:left"} className={"!text-white"} />
      </button>
      <div
        ref={tabsContainerRef}
        className="w-full absolute top-0 bottom-0 left-10 right-10 flex overflow-x-auto hide-scrollbar gap-4 items-center py-2 pr-20 z-10"
      >
        {distanceTabs.map((tab, index) => (
          <button
            key={index}
            type="button"
            className={`text-white text-sm px-10 py-1 rounded-full cursor-pointer transition ${
              Number(mapRadius) === tab?.value
                ? "bg-black/70"
                : "bg-transparent hover:bg-black/50"
            }`}
            onClick={() => handleRadiusChange(tab.value)}
          >
            {tab?.label}
          </button>
        ))}
      </div>
      <button
        type="button"
        onClick={handleRightScrollClick}
        className="absolute bg-black/30 right-0 top-0 bottom-0 w-fit flex items-center justify-center px-2 z-20"
      >
        <Iconify icon={"formkit:right"} className={"!text-white"} />
      </button>
    </div>
  );
};

export default PlacesMapsDistanceFilterTabs;
